






























































































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { setTimeout } from 'timers';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import SecureUpdate from './secure-update.vue';
import TransferConfirmation from './transfer-confirmation.vue';
import SecureUpgradeWraper from './secureupgrade-wraper.vue';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { InfoState } from '@/core/core.store';
import { SwButton } from '@libs-uuif/shared/sw-button';

const cssPrefix = 'register-product-reg';
const CLOUD_SECURE_EDGE: string = 'Cloud Secure Edge';
@Component({
  components: {
    SwSpinningProgress,
    SwTextfield,
    SwIcon,
    SwSelect,
    SwButton,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SecureUpdate,
    TransferConfirmation,
    SecureUpgradeWraper,
  },
})
export default class ProductRegistrationDetails extends SwExtendedVue {
  cssPrefix = cssPrefix;
  noOfFields = 1;
  iconConfig = {
    name: 'checkmark',
    color: '#99CC00',
  };
  iconConfig3 = {
    name: '',
    color: '',
  };
  iconConfig4 = {
    name: 'close',
    color: 'red',
  };
  iptMode: string = '';
  showITPpopup: boolean = false;
  serNum: string = '';
  authCodeForApiCall: string = '';
  authCode : string[] = [];
  friendlyName : string[] = [];
  serialNumber : string[] = [];
  assignToken : string[] = [];
  serialNumberCheck :boolean[] = [];
  serialNumberNotCheck :boolean[] = [];
  friendlyNameCheck :boolean[] = [];
  assignTokenCheck : boolean[] = [];
  authCodeCheck :boolean[] = [];
  snoSpinnerProgress :boolean[] = [];
  showAuthCode: boolean[] = [];
  showFriendlyName: boolean[] = [];
  authCodeSpinner : boolean[] = [];
  assignTokenSpinner : boolean[] = [];
  authCodeNotNeed : boolean = false;
  productTypeName : string[] = [];
  countryName : string[] = [];
  showCountryName : boolean = false;
  inValideAuthCode : boolean = false;
  inValidSno : boolean = false;
  inValidAssignToken : boolean = false;
  latestResponse : any[] = [];
  showSecureUpgrade :boolean[] = [];
  showAssignTokenField :boolean[] = [];
  showSecureUpdateModal : boolean[] = [];
  @Prop({ required: true })
  customerName: any;
  @Prop()
  affiliateTenantText: any;
  retrievedData : any = {};
  secupdateContent : any;
  showTransferConfirmation : boolean = false;
  fieldClicked: any;
  oneCasDone: number = 0;
  oneHesDone: number = 0;
  processing : boolean = true;
  helpContentStep2 : any[] = [];
  skipStepThree : boolean = false;
  showCloudEdgeMessage : boolean = false;
  created() {
    this.focusTextField('serialNumber1');
    this.$emit('moveFurther', false);
    this.serialNumber[this.noOfFields] = '';
    this.authCode[this.noOfFields] = '';
    this.friendlyName[this.noOfFields] = '';
    this.productTypeName[this.noOfFields] = '';
    this.countryName[this.noOfFields] = '';
    this.showSecureUpgrade.push(false);
    this.showSecureUpdateModal.push(false);
    this.serialNumberCheck.push(false);
    this.authCodeCheck.push(false);
    this.friendlyNameCheck.push(false);
    this.assignTokenCheck.push(false);
    this.authCodeSpinner.push(false);
    this.snoSpinnerProgress.push(false);
    this.assignTokenSpinner.push(false);
    this.showAssignTokenField.push(false);
    this.showAuthCode.push(false);
    this.showFriendlyName.push(false);
    this.serialNumberNotCheck.push(false);
    this.latestResponse.push('');
    this.$emit('noOfFields', this.noOfFields);
    this.oneHesDone = 0;
    this.oneCasDone = 0;
  }

  focusTextField(id : any) {
    setTimeout(() => {
      const wrapper2 = document.getElementById(id) as HTMLElement;
      if (wrapper2) {
        console.warn(wrapper2.children[0].getElementsByTagName('input'));
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         300);
  }

  get getTitle() {
    // tslint:disable-next-line
    if (this.iptMode === 'Association') return `${(this.$t('registerProduct.associationHeader')
    .toString())}`;
    // tslint:disable-next-line
    else if (this.iptMode === 'EOS') return `${(this.$t('registerProduct.eosHeader')
    .toString())}`;
    // tslint:disable-next-line
    else if (this.iptMode === 'Transfer') return `${(this.$t('registerProduct.transferHeader')
    .toString())}`;
    else return '';
  }

  get note1() {
    // tslint:disable-next-line
    if (this.iptMode === 'Association') return `${(this.$t('registerProduct.association1')
    .toString())}`;
    // tslint:disable-next-line
    if (this.iptMode === 'EOS') return `${(this.$t('registerProduct.eos1')
    .toString())}`;
    // tslint:disable-next-line
    if (this.iptMode === 'Transfer') return `${(this.$t('registerProduct.transfer1')
    .toString())}`;
  }

  get note2() {
    // tslint:disable-next-line
    if (this.iptMode === 'Association') return `${(this.$t('registerProduct.association2')
    .toString())}`;
    // tslint:disable-next-line
    if (this.iptMode === 'EOS') return `${(this.$t('registerProduct.eos2')
    .toString())}`;
    // tslint:disable-next-line
    if (this.iptMode === 'Transfer') return `${(this.$t('registerProduct.transfer2')
    .toString())}`;
  }
  get note3() {
    // tslint:disable-next-line
    if (this.iptMode === 'Association') return `${(this.$t('registerProduct.association3')
    .toString())}`;
    // tslint:disable-next-line
    if (this.iptMode === 'EOS') return `${(this.$t('registerProduct.eos3')
    .toString())}`;
    // tslint:disable-next-line
    if (this.iptMode === 'Transfer') return `${(this.$t('registerProduct.transfer3')
    .toString())}`;
  }
  serialNumberValidation(field : any) {
    // tslint:disable:no-unused
    this.$emit('moveFurther', false);
    this.inValideAuthCode = false;
    if (this.serialNumber[field].trim().length === 12) {
      if (this.showCloudEdgeMessage) {
        this.showCloudEdgeMessage = false;
      }
      if (this.authCode[field].length > 7) {
        this.authCodeValidation({} , field);
      }
      if (this.snoRegexCheck(field)) {
        // tslint:disable-next-line:prefer-template
        this.focusTextField('authCode' + field);
        this.$set(this.snoSpinnerProgress, field, false);
        this.$set(this.showAuthCode, field, true);
        this.$set(this.showFriendlyName, field, true);
        this.authCodeNotNeed = false;
        this.$set(this.showAssignTokenField, field , false);
        this.assignToken[field] = '';
      } else {
        const res = {
          operationStatus : 'NOK',
          msgDesc : 'Invalid serial number.',
        };
        this.$emit('errorMsg', res);
        this.resetAllvalues(field);
      }
    } else if (this.serialNumber[field].trim().length === 8 && !this.snoSpinnerProgress[field]) {
      setTimeout(() => {
        if (this.serialNumber[field].trim().length === 8 && !this.snoSpinnerProgress[field]) {
          if (this.showCloudEdgeMessage) {
            this.showCloudEdgeMessage = false;
          }
          const req = {
            productGroupId : this.customerName.productGroupId,
            serialNumber : this.serialNumber[field].toUpperCase()
            .toString()
            .trim(),
          };
          this.$set(this.snoSpinnerProgress, field, true);
          this.$set(this.serialNumberCheck, field, false);
          this.$set(this.authCodeCheck, field, false);
          this.$set(this.assignTokenCheck, field,  false);
          this.$set(this.showSecureUpgrade, field, false);
          this.$store.dispatch('MswProductsStoreModule/serialNumberValidation', req)
      .then((res) => {
        this.latestResponse[field] = res;
        this.$set(this.snoSpinnerProgress, field, false);
        if (res.operationStatus === 'OK') {
          this.$store.commit('MswProductsStoreModule/setValidateSerialNumberData', res?.content || {});
          // tslint:disable-next-line:prefer-template
          this.focusTextField('friendlyName' + field);
          const isCSEProduct: boolean = res.content.productType === CLOUD_SECURE_EDGE;
          if (res.content.isHESservice) {
            this.$set(this.showFriendlyName, field, true);
            if (this.checkMultipleHes()) {
              this.successOperations(field, res);
            } else {
              res.operationStatus = 'NOK';
              res.msgDesc = (this.$t('registerProduct.validationMsg1')
              .toString());
              this.errorOperation(field , res);
            }
          } else if (res.content.isCasService) {
            this.$set(this.showFriendlyName, field, true);
            if (this.checkMultipleCas()) {
              this.successOperations(field, res);
            } else {
              res.operationStatus = 'NOK';
              res.msgDesc = (this.$t('registerProduct.validationMsg2')
              .toString());
              this.errorOperation(field , res);
            }
          } else if (res.content.isSASEService) {
            this.showCloudEdgeMessage = true;
            this.$set(this.showFriendlyName, field, false);
            this.successOperations(field, res);
          } else if (res.content.isCESService) {
            // this.showCloudEdgeMessage = true;
            this.$set(this.showFriendlyName, field, false);
            this.successOperations(field, res);
          } if (res.content.isccclinet) {
            if (field > 1) {
              res.operationStatus = 'NOK';
              res.msgDesc = (this.$t('registerProduct.validationMsg3')
              .toString());
              this.errorOperation(field , res);
            } else {
              this.$set(this.showFriendlyName, field, true);
              this.successOperations(field, res);
            }
          } else if (res.content.isMDRService) {
            this.$set(this.showFriendlyName, field, true);
            this.successOperations(field, res);
          } else if (isCSEProduct) {
            this.$set(this.showFriendlyName, field, false);
            this.successOperations(field, res);
          } else {
            this.$set(this.showFriendlyName, field, true);
            this.successOperations(field, res);
          }
        } else if (res.operationStatus === 'NOK') {
          this.errorOperation(field , res);
        }
      });
        } else {
          if (!this.snoSpinnerProgress[field]) {
            this.resetAllvalues(field);
          }
        }
      },         500);
    } else {
      if (!this.snoSpinnerProgress[field]) {
        this.resetAllvalues(field);
      }
    }
  }

  checkForDuplicate(field : any) {
    // to supress two key press event while copy pasting.
    if (this.processing) {
      this.processing = true;
      const filteredDuplicate = this.serialNumber.filter((each:any, index:any) => {
        if (each === this.serialNumber[field] && index !== field) {
          return true;
        }
      });
      console.warn(this.serialNumber);
      console.warn(filteredDuplicate);
      if (filteredDuplicate.length > 0) {
        setTimeout(() => {
          this.processing = true;
          // disabled checking duplicate
          return true;
        },         500);
      }
      return true;
    }
  }

  successOperations(field : any, res : any) {
    this.$set(this.serialNumberCheck, field, true);
    this.$set(this.productTypeName, field, res.content.productType ? res.content.productType : '');
    this.$set(this.countryName, field, res.content.wirelessLocation !== '  ' && res.content.wirelessLocation !== '' ? res.content.wirelessLocation : 'N/A');
    this.authCodeNotNeed = true;
    this.$set(this.showAuthCode, field, false);
    this.$emit('errorMsg', res);
    this.getMoveFurther();
    this.responseChange();
  }

  errorOperation(field : any, res : any) {
    this.$emit('moveFurther', false);
    this.$emit('errorMsg', res);
    this.inValidSno = true;
    this.resetAllvalues(field);
    this.responseChange();
  }

  checkMultipleCas() {
    this.oneCasDone = 0;
    for (let i = 1; i < this.latestResponse.length ; i += 1) {
      console.warn(this.latestResponse[i]);
      if (this.latestResponse[i].content.isCasService && this.oneCasDone === 0) {
        this.oneCasDone += 1;
      } else if (this.latestResponse[i].content.isCasService && this.oneCasDone === 1) {
        this.oneCasDone += 1;
        break;
      }
    }
    if (this.oneCasDone === 2) {
      return false;
    }
    return true;
  }

  checkMultipleHes() {
    this.oneHesDone = 0;
    for (let i = 1; i < this.latestResponse.length ; i += 1) {
      console.warn(this.latestResponse[i]);
      if (this.latestResponse[i].content.isHESservice && this.oneCasDone === 0) {
        this.oneHesDone += 1;
      } else if (this.latestResponse[i].content.isHESservice && this.oneCasDone === 1) {
        this.oneHesDone += 1;
        break;
      }
    }
    if (this.oneHesDone === 2) {
      return false;
    }
    return true;
  }

  responseChange() {
    let stepTwoFlag = false;
    for (let i = 1 ; i < this.serialNumber.length ; i += 1) {
      const ele = this.latestResponse[i].content;
      if (ele.hasOwnProperty('productType')) {
        if (!(ele.productType.indexOf('NSM ON-PREM') > -1)) {
          if (ele.isccclinet && ele.hasOwnProperty('casDataCenter')) {
            stepTwoFlag = true;
          } else if (!ele.isccclinet) {
            stepTwoFlag = true;
          }
        } else if (ele.productType.toLowerCase() === 'nsm on-prem' && this.skipStepThree) {
          stepTwoFlag = false;
        } else if (ele.productType.indexOf('NSM ON-PREM') > -1) {
          stepTwoFlag = true;
        }
        if (ele.productType.toLowerCase() === 'volume license') {
          stepTwoFlag = false;
        }
        if (ele.productType.toLowerCase() === 'email security' && ele?.isEmailSecurityFreetrial) {
          stepTwoFlag = false;
        }
      }
      if (ele.isccclinet && ele.hasOwnProperty('casDataCenter')) {
        stepTwoFlag = true;
      }
      if (ele.arrListOffSite) {
        stepTwoFlag = true;
      }
      if (ele.switchoptions) {
        stepTwoFlag = true;
      }
      if (ele.arrCaptureAtpDc) {
        stepTwoFlag = true;
      }
      if (ele.isMDRService && ele.hasOwnProperty('mdrDataCenter') && ele.mdrDataCenter.length > 0) {
        stepTwoFlag = true;
      } else if (ele.isMDRService && !ele.hasOwnProperty('mdrDataCenter')) {
        stepTwoFlag = false;
      }
      if (stepTwoFlag) {
        break;
      }
    }
    this.retrievedData = {
      serialNumber : this.serialNumber,
      authCode : this.authCode,
      friendlyName : this.friendlyName,
      productTypeName : this.productTypeName,
      response : this.latestResponse,
      stepTwoShowFlag : stepTwoFlag,
    };
    console.warn(this.retrievedData);
    this.$emit('retrievedData', this.retrievedData);
    console.warn('hit111');
  }

  snoRegexCheck(field : any) {
    const str1 = '(0006B1)[abcdefABCDEF0-9]{6}$';
    const str2 = '(00900b)[abcdefABCDEF0-9]{6}$';
    const str3 = '(0017C5)[abcdefABCDEF0-9]{6}$';
    const str4 = '(CD0000)[abcdefABCDEF0-9]{6}$';
    const str5 = '(18B169)[abcdefABCDEF0-9]{6}$';
    const str6 = '(C0EAE4)[abcdefABCDEF0-9]{6}$';
    const str7 = '(00026F)[abcdefABCDEF0-9]{6}$';
    const str8 = 'FS';
    const str9 = '(0017C3)[abcdefABCDEF0-9]{6}$';
    const str10 = '(SLI080)[abcdefABCDEF0-9]{6}$';
    const str11 = '(BB0000)[abcdefABCDEF0-9]{6}$';
    const str12 = '(CC0000)[abcdefABCDEF0-9]{6}$';
    const str13 = '(004010)[abcdefABCDEF0-9]{6}$';
    const str14 = '(AA0401)[abcdefABCDEF0-9]{6}$';
    const str15 = '(0060F5)[abcdefABCDEF0-9]{6}$';
    const str16 = '(2CB8ED)[abcdefABCDEF0-9]{6}$';
    const str17 = '(F2C784)[abcdefABCDEF0-9]{6}$';
    const str18 = '(18C241)[abcdefABCDEF0-9]{6}$';
    const str19 = '(FAC793)[abcdefABCDEF0-9]{6}$';
    const strArray = [str1 , str2 , str3 , str4 , str5 , str6 , str7 , str9 , str10 , str11 , str12 , str13 , str15 , str16, str17, str18, str19];
    console.warn(strArray);
    let validSerialNumber: boolean = false;
    strArray.forEach((str) => {
      if (!validSerialNumber) {
        const codeRegex = new RegExp(str.toString()
        .toUpperCase());
        if (codeRegex.test(this.serialNumber[field].trim()
        .toString()
        .toUpperCase())) {
          console.warn(str);
          validSerialNumber = true;
        }
      }
    });
    return validSerialNumber;
  }

  resetAllvalues(field : any) {
    console.warn('checked last');
    const temp = [];
    temp.push('register-default');
    temp.push('bulkRegistration');
    field === 1 && this.noOfFields === 1 ?  this.$emit('setHelpContent', temp) : '';
    this.$set(this.snoSpinnerProgress, field, false);
    this.$set(this.serialNumberCheck, field, false);
    this.$set(this.showAuthCode, field, false);
    this.$set(this.authCodeCheck, field, false);
    this.$set(this.assignTokenCheck, field, false);
    this.$set(this.friendlyNameCheck, field, false);
    this.$set(this.showFriendlyName, field, false);
    this.$set(this.showSecureUpgrade, field, false);
    this.$set(this.showAssignTokenField, field , false);
    this.authCode[field] = '';
    this.friendlyName[field] = '';
    this.assignToken[field] = '';
  }

  friendlyNameValidation(field : any) {
    if (this.friendlyName[field].length > 0) {
      this.responseChange();
    }
  }

  authCodeValidation(event:any , field : any) {
    this.$emit('moveFurther', false);
    this.inValideAuthCode = false;
    this.inValidSno = false;
    if (this.authCode[field].replace('-', '')
    .trim().length > 7 && !this.authCodeSpinner[field]) {
      if (this.checkForDuplicate(field)) {
        this.$set(this.authCodeSpinner, field, true);
        this.$set(this.authCodeCheck, field, false);
        this.$set(this.serialNumberCheck, field, false);
        const req = {
          productGroupId : this.customerName.productGroupId,
          serialNumber : this.serialNumber[field].toUpperCase()
          .toString()
          .trim() ,
          authCode : this.authCode[field].toUpperCase()
          .toString()
          .replace('-' , '')
          .trim(),
        };
        this.$store.dispatch('MswProductsStoreModule/serialNumberValidation', req)
        .then((res) => {
          this.serNum = this.serialNumber[field].toUpperCase()
          .toString()
          .trim();
          this.authCodeForApiCall = this.authCode[field].toUpperCase()
          .toString()
          .replace('-' , '')
          .trim();
          this.fieldClicked = field;
          this.latestResponse[field] = res;
          if (this.latestResponse[this.noOfFields].content.hasOwnProperty('productType')) {
            if (this.latestResponse[this.noOfFields].content.productType.indexOf('NSM ON-PREM') > -1) {
              if (field > 1) {
                res.operationStatus = 'NOK';
                res.msgDesc = 'Multi product registration is not supported with capture client.';
                // this.errorOperation(field , res);
              }
            }
          }
          if (res.operationStatus === 'OK') {
            this.$store.commit('MswProductsStoreModule/setValidateSerialNumberData', res?.content || {});
            this.showCountryName = res.content.isGen7Wireless === 'YES';
            // tslint:disable-next-line:prefer-template
            this.focusTextField('friendlyName' + field);
            this.$set(this.authCodeCheck, field, true);
            this.$set(this.serialNumberCheck, field, true);
            this.$set(this.authCodeSpinner, field, false);
            this.$set(this.productTypeName, field, res.content.productType ? res.content.productType : '');
            this.$set(this.countryName, field, res.content.wirelessLocation !== '  ' && res.content.wirelessLocation !== '' ? res.content.wirelessLocation : 'N/A');
            this.$emit('errorMsg', res);
            this.getMoveFurther();
            if (res.content.issecureupgrade || res.content.isstoragesata) {
              console.warn(field);
              this.$set(this.showSecureUpgrade, field, true);
            } else {
              this.$set(this.showSecureUpgrade, field, false);
            }
            if (res.content.isAWSProduct) {
              // tslint:disable-next-line:prefer-template
              this.focusTextField('assignToken' + field);
              this.$set(this.showAssignTokenField, field , true);
              if (this.assignToken[field] !== '') {
                this.assignTokenValidation(field);
              } else {
                this.resetAssignTokenValues(field);
              }
            } else {
              if (this.serialNumberCheck[field] && this.authCodeCheck[field]) {
                this.$emit('moveFurther', true);
              }
              this.$set(this.showAssignTokenField, field , false);
            }
            this.responseChange();
          } else if (res.operationStatus === 'NOK') {
            if (res.content.iptMode === 'PENDING') {
              const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.pendingMessage')
              .toString()) };
              this.$store.commit('enqueueMessage', message);
              this.$set(this.authCodeCheck, field, true);
              this.$set(this.authCodeSpinner, field, false);
              this.$emit('moveFurther', false);
              this.serialNumber[this.noOfFields] = '';
              this.authCode[this.noOfFields] = '';
              this.resetAuthCodeValues(field);
              this.responseChange();
            } else if (res.content.iptMode !== '' && res.content.iptMode !== null && res.content.iptMode !== undefined && res.content.iptMode !== 'undefined') {
              this.showITPpopup = true;
              this.iptMode = '';
              if (res.content.iptMode === 'INITDEVICEASS') this.iptMode = 'Association';
              if (res.content.iptMode === 'INITEOS') this.iptMode = 'EOS';
              if (res.content.iptMode === 'INITTRANSFER') this.iptMode = 'Transfer';
              this.$set(this.authCodeCheck, field, true);
              this.$set(this.authCodeSpinner, field, false);
              this.$emit('moveFurther', false);
              // this.$emit('errorMsg', res);
              // this.inValideAuthCode = true;
              // this.inValidSno = true;
              this.resetAuthCodeValues(field);
              this.responseChange();
            } else if (res.msgCode === 'MSWAPP:REGISTEREDTOOTHERUSER' && res.content.isAPT) {
              this.$set(this.productTypeName, field, res.content.productType ? res.content.productType : '');
              this.$set(this.countryName, field, res.content.wirelessLocation !== '  ' && res.content.wirelessLocation !== '' ? res.content.wirelessLocation : 'N/A');
              this.$set(this.authCodeCheck, field, true);
              this.$set(this.authCodeSpinner, field, false);
              this.$set(this.serialNumberCheck, field, true);
              this.showTransferConfirmation = true;
              if (this.serialNumberCheck[field] && this.authCodeCheck[field]) {
                this.$emit('moveFurther', true);
              }
              this.responseChange();
            } else if (res.content.isFreeSerialNumber && this.noOfFields === 1) {
              this.$set(this.countryName, field, res.content.wirelessLocation !== '  ' && res.content.wirelessLocation !== '' ? res.content.wirelessLocation : 'N/A');
              this.$set(this.productTypeName, field, res.content.productType ? res.content.productType : '');
              this.$set(this.authCodeCheck, field, true);
              this.$set(this.authCodeSpinner, field, false);
              this.$set(this.serialNumberCheck, field, true);
              if (this.serialNumberCheck[field] && this.authCodeCheck[field]) {
                this.$emit('moveFurther', true);
              }
              this.responseChange();
              this.$set(this.showSecureUpgrade, field, true);
            } else {
              this.$emit('moveFurther', false);
              this.$emit('errorMsg', res);
              if (res.msgCode === 'MSWAPP:INVALIDSERNOAUTHCODE') {
                this.inValideAuthCode = true;
              } else if (res.msgCode === 'MSWAPP:SERNONOTINDB') {
                this.inValidSno = true;
              } else {
                this.inValideAuthCode = true;
                this.inValidSno = true;
              }
              this.resetAuthCodeValues(field);
              this.responseChange();
            }
          }
        });
      } else {
        const res = {
          operationStatus : 'NOK',
          msgDesc : 'Duplicate serial number.',
        };
        this.$emit('errorMsg', res);
        this.resetAuthCodeValues(field);
        // this.resetAllvalues(field);
      }
    } else {
      if (this.authCodeSpinner[field]) {
        this.$set(this.serialNumberCheck, field, false);
        this.$set(this.authCodeCheck, field, false);
      } else {
        this.resetAuthCodeValues(field);
      }
    }
  }

  initiateTransfer() {
    const req = {
      productGroupId : this.customerName.productGroupId,
      serialNumber : this.serNum,
      authCode : this.authCodeForApiCall,
    };
    this.$store.dispatch('MswProductsStoreModule/initiateTransfer', req)
    .then((res) => {
      this.$store.commit('stopLoading');
      if (res.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else if (res.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.serialNumber[this.noOfFields] = '';
      this.authCode[this.noOfFields] = '';
      this.showITPpopup = false;
      this.iptMode = '';
    });
  }

  closeIPT() {
    this.showITPpopup = false;
    this.serialNumber[this.noOfFields] = '';
    this.authCode[this.noOfFields] = '';
  }

  assignTokenValidation(field: any) {
    this.$emit('moveFurther', false);
    this.inValidAssignToken = false;
    if (this.assignToken[field].length > 7 && !this.assignTokenSpinner[field] && this.serialNumberCheck[field] && this.authCodeCheck[field]) {
      setTimeout(() => {
        if (this.assignToken[field].length > 7 && !this.assignTokenSpinner[field]) {
          this.$set(this.assignTokenSpinner, field , true);
          this.$set(this.assignTokenCheck, field , false);
          const req = {
            productGroupId : this.customerName.productGroupId,
            serialNumber : this.serialNumber[field].toUpperCase()
            .toString()
            .trim() ,
            authCode : this.authCode[field].toUpperCase()
            .toString()
            .replace('-' , '')
            .trim(),
            awsAssignToken : this.assignToken[field].toUpperCase()
            .toString()
            .trim(),
            isawsToken : true,
          };
          this.$store.dispatch('MswProductsStoreModule/serialNumberValidation', req)
        .then((res) => {
          this.$set(this.assignTokenSpinner, field , false);
          if (res.operationStatus === 'OK') {
            this.$store.commit('MswProductsStoreModule/setValidateSerialNumberData', res?.content || {});
            // tslint:disable-next-line:prefer-template
            this.focusTextField('friendlyName' + field);
            this.inValidAssignToken = false;
            this.$set(this.assignTokenCheck, field , true);
            this.$emit('moveFurther', true);
            this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'assignToken', key : field , value : this.assignToken[field] });
          } else if (res.operationStatus === 'NOK') {
            this.inValidAssignToken = true;
            this.$emit('moveFurther', false);
            this.$set(this.assignTokenCheck, field , false);
            this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'assignToken', key : field , value : '' });
          }
        });
        } else {
          this.resetAssignTokenValues(field);
        }
      },         500);
    } else {
      this.resetAssignTokenValues(field);
    }
  }

  resetAssignTokenValues(field : any) {
    this.$set(this.assignTokenCheck , field , false);
    this.$emit('moveFurther', false);
    this.$store.commit('MswProductsStoreModule/mapMutate', { property: 'assignToken', key : field , value : '' });
  }

  resetAuthCodeValues(field : any) {
    const temp = [];
    temp.push('register-default');
    temp.push('bulkRegistration');
    field === 1 && this.noOfFields === 1 ?  this.$emit('setHelpContent', temp) : '';
    this.$set(this.serialNumberCheck, field, false);
    this.$set(this.authCodeCheck, field, false);
    this.$set(this.authCodeSpinner, field, false);
    this.$set(this.assignTokenCheck, field, false);
    this.$set(this.showSecureUpgrade, field, false);
  }

  methodToShowAddLine() {
    if (this.serialNumberCheck[this.noOfFields]) {
      if (this.showAssignTokenField[this.noOfFields]) {
        if (this.assignTokenCheck[this.noOfFields]) {
          return true;
        }
        return false;
      }
      return true;
    }
    return false;
  }
  addSerialNumber() {
    let move = true;
    if (this.methodToShowAddLine()) {
      if (this.latestResponse[this.noOfFields].content.issecureupgrade) {
        const secureUpdateData = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
        // console.warn(secureUpdateData.get(this.noOfFields));
        if (secureUpdateData.get(this.noOfFields) === '') {
          move = false;
          const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.infoMsg1')
          .toString()) };
          this.$store.commit('enqueueMessage', message);
        } else {
          if (secureUpdateData.get(this.noOfFields).length > 1) {
            // tslint:disable-next-line:max-line-length
            const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.infoMsg2')
            .toString()) };
            this.$store.commit('enqueueMessage', message);
            move = false;
          }
        }
      } else if (this.latestResponse[this.noOfFields].content.isstoragesata) {
        const storageData = this.$store.getters['MswProductsStoreModule/getStorageSata'];
        console.warn(storageData.get(this.noOfFields));
        if (storageData.get(this.noOfFields) === '') {
          move = false;
          const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.infoMsg3')
          .toString()) };
          this.$store.commit('enqueueMessage', message);
        }
      } else if (this.latestResponse[this.noOfFields].content.isFreeSerialNumber) {
        const freeTrail = this.$store.getters['MswProductsStoreModule/getFreeTrailSerNo'];
        if (freeTrail.get(this.noOfFields) === '') {
          move = false;
          const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.infoMsg4')
          .toString()) };
          this.$store.commit('enqueueMessage', message);
        } else if (this.noOfFields === 1) {
          move = false;
          // tslint:disable-next-line:max-line-length
          const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.infoMsg5')
          .toString()) };
          this.$store.commit('enqueueMessage', message);
        }
      } else if (this.latestResponse[this.noOfFields].content.isccclinet) {
        if (this.noOfFields === 1) {
          move = false;
          // tslint:disable-next-line:max-line-length
          const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('registerProduct.infoMsg6')
          .toString()) };
          this.$store.commit('enqueueMessage', message);
        }
      } else if (this.latestResponse[this.noOfFields].content.hasOwnProperty('productType')) {
        if (this.latestResponse[this.noOfFields].content.productType.indexOf('NSM ON-PREM') > -1) {
          if (this.noOfFields === 1) {
            move = false;
            // tslint:disable-next-line:max-line-length
            const message: InfoState = { infoType: 'failed', infoMsg: `${(this.$t('registerProduct.infoMsg7')
            .toString())} ${this.latestResponse[this.noOfFields].content.productType}` };
            this.$store.commit('enqueueMessage', message);
          }
        }
      }
    }
    if (this.methodToShowAddLine() && move) {
      this.noOfFields += 1;
      this.serialNumber[this.noOfFields] = '';
      this.authCode[this.noOfFields] = '';
      this.friendlyName[this.noOfFields] = '';
      this.$emit('moveFurther', false);
      // tslint:disable-next-line:prefer-template
      this.focusTextField('serialNumber' + this.noOfFields);
    }
  }
  getIcon(field : any)  {
    if (this.serialNumberCheck[field]) {
      return this.iconConfig;
    }
    const len = this.serialNumber[field].length;
    if (this.inValidSno) {
      return this.iconConfig4;
    }
    return this.iconConfig3;
  }

  cancelRegister(value : any) {
    if (value === 'failed') {
      this.$emit('moveFurther', false);
      const res = {
        operationStatus : 'NOK',
        msgDesc : 'Invalid AuthCode',
      };
      this.$emit('errorMsg', res);
      this.inValideAuthCode = true;
      this.inValidSno = true;
      this.resetAuthCodeValues(this.fieldClicked);
      this.responseChange();
    } else {
      this.showTransferConfirmation = false;
      this.serialNumber[this.fieldClicked] = '';
      this.resetAllvalues(this.fieldClicked);
      this.$emit('moveFurther', false);
    }
  }

  requestData() {
    console.warn(this.latestResponse[this.fieldClicked]);
    return this.latestResponse[this.fieldClicked];
  }
  showProductType(field : any) {
    if (this.serialNumberCheck[field]) {
      if (this.showAuthCode[field]) {
        return this.authCodeCheck[field];
      }
      if (!this.showAuthCode[field]) {
        return true;
      }
    }
    return false;
  }

  getMoveFurther() {
    let moveFurther = true;
    for (let i = 1 ; i <= this.noOfFields ; i += 1) {
      if (this.serialNumberCheck[i]) {
        if (this.showAuthCode[i]) {
          moveFurther = this.authCodeCheck[i];
          if (!this.authCodeCheck[i]) {
            break;
          }
        }
      } else {
        moveFurther = false;
        break;
      }
    }
    this.$emit('moveFurther', moveFurther);
  }

  deleteRow(field : any) {
    this.noOfFields -= 1;
    this.retrievedData.authCode.splice(field, 1);
    this.retrievedData.friendlyName.splice(field, 1);
    this.retrievedData.response.splice(field, 1);
    this.retrievedData.serialNumber.splice(field, 1);
    this.resetAuthCodeValues(field);
    this.resetAllvalues(field);
    this.responseChange();
    this.methodToShowAddLine() ? this.$emit('moveFurther', true) : this.$emit('moveFurther', false);
    console.warn(this.noOfFields);
    console.warn(this.retrievedData);
    if (this.noOfFields >= 1) {
      if (this.retrievedData.response[this.noOfFields].hasOwnProperty('content')) {
        if (this.retrievedData.response[this.noOfFields].content.isSASEService) {
          this.showCloudEdgeMessage = true;
        } else {
          this.showCloudEdgeMessage = false;
        }
      }
    }
  }
  skipStep3(val : any) {
    this.skipStepThree = val;
    console.warn(val);
    this.responseChange();
  }
  onClickauthCodeIcon() {
    const url = 'https://www.mysonicwall.com/help/help.aspx?LOCALE=en&CONTEXT=PRODUCTREGISTRATION&SUBCONTEXT=AUTHENTICATIONCODE';
    window.open(url, '_blank');
  }
}
